import BaseService from "./base.service";
import {API_URL} from "../config/constants";
import axios from "axios";

export default class ActualiteService extends BaseService {
  constructor() {
    super();
    this.API_URL = API_URL + "actualites/";
  }

  // Get all active news for public display
  async getActiveActualites() {
    return axios
      .get(this.API_URL + "active")
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching active news:", error);
        throw error;
      });
  }

  // Get all news for admin
  async getAllActualites() {
    return axios
      .get(this.API_URL)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching all news:", error);
        throw error;
      });
  }

  // Get single news article by ID
  async getActualiteById(id) {
    return axios
      .get(this.API_URL + id)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error fetching news article:", error);
        throw error;
      });
  }

  // Create new news article
  async createActualite(data) {
    return axios
      .post(this.API_URL, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error creating news article:", error);
        throw error;
      });
  }

  // Update news article
  async updateActualite(id, data) {
    return axios
      .put(this.API_URL + id, data)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error updating news article:", error);
        throw error;
      });
  }

  // Delete news article
  async deleteActualite(id) {
    return axios
      .delete(this.API_URL + id)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleting news article:", error);
        throw error;
      });
  }
} 